import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import hi from "./hi.json";

export const SUPPORTED_LANGS = [
    { code: "en", label: "English", short: "EN" },
    { code: "hi", label: "हिन्दी", short: "हिं" },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hi: { translation: hi },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "hi"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "np_lang",
            caches: ["localStorage"],
        },
    });

// Reflect current language on <html lang=...>
const syncHtmlLang = () => {
    if (typeof document !== "undefined") {
        document.documentElement.lang = i18n.language || "en";
    }
};
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang();

export default i18n;
